import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackAddedShareLinkExpirationDate } from "@air/analytics";
import { Button } from "@air/primitive-button";
import { DateInput } from "@air/primitive-date-input";
import { Switch } from "@air/primitive-switch";
import { parseAirDateToISO } from "@air/utilities";
import classNames from "classnames";
import { endOfDay, isBefore, startOfToday } from "__barrel_optimize__?names=endOfDay,isBefore,startOfToday!=!date-fns";
import { useCallback, useEffect, useMemo, useState } from "react";
import { UpsellButton } from "~/components/UpsellButton";
import { EXPIRATION_DATE_INPUT, EXPIRATION_DATE_LABEL, EXPIRATION_DATE_SUBMIT_BUTTON, EXPIRATION_DATE_TOGGLE } from "~/constants/testIDs";
import { useSubscriptionContext } from "~/providers/SubscriptionProvider";
export const SharePrivateContentExpirationDateSetting = (param)=>{
    let { shortIdInfo, onChangeExpirationDate } = param;
    const [hasExpirationDate, setHasExpirationDate] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const expirationDate = useMemo(()=>(shortIdInfo === null || shortIdInfo === void 0 ? void 0 : shortIdInfo.expirationDate) ? parseAirDateToISO(shortIdInfo === null || shortIdInfo === void 0 ? void 0 : shortIdInfo.expirationDate) : undefined, [
        shortIdInfo === null || shortIdInfo === void 0 ? void 0 : shortIdInfo.expirationDate
    ]);
    const [dateValue, setDateValue] = useState(expirationDate);
    const { data: memberSubscription } = useSubscriptionContext();
    const isOnProPlan = !!(memberSubscription === null || memberSubscription === void 0 ? void 0 : memberSubscription.isOnProPlan);
    const shortId = useMemo(()=>shortIdInfo === null || shortIdInfo === void 0 ? void 0 : shortIdInfo.id, [
        shortIdInfo === null || shortIdInfo === void 0 ? void 0 : shortIdInfo.id
    ]);
    const [errorText, setErrorText] = useState("");
    const { trackAddedShareLinkExpirationDate } = useTrackAddedShareLinkExpirationDate();
    useEffect(()=>{
        if (!!expirationDate) {
            setDateValue(expirationDate);
        }
    }, [
        expirationDate
    ]);
    useEffect(()=>{
        setHasExpirationDate(!!expirationDate);
    }, [
        setHasExpirationDate,
        expirationDate
    ]);
    const onSave = useCallback(async (e)=>{
        e.preventDefault();
        if (!shortId) return;
        try {
            setIsSubmitting(true);
            trackAddedShareLinkExpirationDate({
                shortId
            });
            await onChangeExpirationDate((dateValue === null || dateValue === void 0 ? void 0 : dateValue.toISOString()) || null);
            setIsSaved(true);
            setIsSubmitting(false);
        } catch (_error) {
            setIsSubmitting(false);
        }
    }, [
        shortId,
        dateValue,
        onChangeExpirationDate,
        trackAddedShareLinkExpirationDate
    ]);
    const toggleExpirationDate = async ()=>{
        const nextHasExpirationDate = !hasExpirationDate;
        if (!!expirationDate && !nextHasExpirationDate && shortId) {
            await onChangeExpirationDate(null);
        }
        setIsSaved(false);
        setDateValue(undefined);
        setErrorText("");
        setHasExpirationDate(nextHasExpirationDate);
    };
    const onDateChange = useCallback((date)=>{
        const endOfDate = date ? endOfDay(date) : date;
        setDateValue(endOfDate);
        if (endOfDate && isBefore(endOfDate, startOfToday())) {
            setErrorText("Expiration date cannot be set in the past");
        } else {
            setErrorText("");
        }
        if (endOfDate !== expirationDate) setIsSaved(false);
    }, [
        expirationDate
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-14 text-grey-12",
                        "data-testid": EXPIRATION_DATE_LABEL,
                        children: "Add an expiration date"
                    }),
                    !isOnProPlan ? /*#__PURE__*/ _jsx(UpsellButton, {
                        children: "Upgrade to Air Pro"
                    }) : /*#__PURE__*/ _jsx(Switch, {
                        checked: hasExpirationDate,
                        "data-testid": EXPIRATION_DATE_TOGGLE,
                        onCheckedChange: toggleExpirationDate
                    })
                ]
            }),
            isOnProPlan && hasExpirationDate && /*#__PURE__*/ _jsxs("form", {
                className: classNames("mt-3", errorText ? "mb-3" : "mb-0"),
                onSubmit: onSave,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "relative mt-3 flex items-center",
                        children: [
                            /*#__PURE__*/ _jsx(DateInput, {
                                size: "large",
                                testId: EXPIRATION_DATE_INPUT,
                                className: "w-full",
                                name: "expiration-date",
                                selected: dateValue,
                                onChange: onDateChange
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                appearance: "filled",
                                className: "ml-3",
                                color: "grey",
                                "data-testid": EXPIRATION_DATE_SUBMIT_BUTTON,
                                disabled: isSubmitting || isSaved || !!errorText || !dateValue,
                                isLoading: isSubmitting,
                                size: "large",
                                type: "submit",
                                children: isSaved ? "Saved" : "Save"
                            })
                        ]
                    }),
                    !!errorText && /*#__PURE__*/ _jsx("p", {
                        className: "mt-1 text-12 text-red-9",
                        "data-testid": "".concat(EXPIRATION_DATE_INPUT, "-error"),
                        children: errorText
                    })
                ]
            })
        ]
    });
};
